import { render } from "./DashboardUser.vue?vue&type=template&id=7338c542&scoped=true"
import script from "./DashboardUser.vue?vue&type=script&lang=js"
export * from "./DashboardUser.vue?vue&type=script&lang=js"

import "./DashboardUser.vue?vue&type=style&index=0&id=7338c542&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7338c542"]])

export default __exports__